import { OVERLAY_CARD_IMAGE_HEIGHT } from '@/app/components/search/components/EvolutionCard/Gallery/styled.ts';
import {
  CARD_MIN_HEIGHT,
  LARGE_IMAGE_WIDTH,
  OVERLAY_WIDTH_EVOLUTION,
} from '@/app/components/search/components/EvolutionCard/constants.ts';
import type { ImageSize } from '@/app/components/search/utils/images.ts';

/** The mobile overlay slot, hardcoded in Gallery/GalleryItem/styled.ts. */
const MOBILE_OVERLAY_WIDTH = 104;
const MOBILE_OVERLAY_HEIGHT = 136;
/**
 * Mobile is full-bleed with `aspect-ratio: 2 / 1`, whatever the number of images: 400px is the
 * middle of the phone range, and the 2x candidate covers it up to an 800px-wide device pixel box.
 */
const MOBILE_WIDTH = 400;

/**
 * Size of the box the gallery image is painted into, in CSS pixels. It feeds the `width`/`height`
 * attributes and the CDN transformation alike, so the image requested is the image displayed.
 *
 * Desktop takes the widest of the two slots, so the narrower BASE_IMAGE_WIDTH (276px) one is never
 * upscaled. The rest read from the constants the stylesheets lay the card out with, so a change
 * there cannot leave the requested image behind.
 */
export const getImageSize = ({ isOverlay, isMobile }: { isOverlay: boolean; isMobile: boolean }): ImageSize => {
  if (isOverlay && isMobile) {
    return {
      width: MOBILE_OVERLAY_WIDTH,
      height: MOBILE_OVERLAY_HEIGHT,
    };
  }
  if (isOverlay) {
    return {
      width: parseInt(OVERLAY_WIDTH_EVOLUTION, 10),
      height: OVERLAY_CARD_IMAGE_HEIGHT,
    };
  }
  if (isMobile) {
    return {
      width: MOBILE_WIDTH,
      height: MOBILE_WIDTH / 2,
    };
  }
  return {
    width: parseInt(LARGE_IMAGE_WIDTH, 10),
    height: parseInt(CARD_MIN_HEIGHT, 10),
  };
};
